<template>
  <div id="document-content-dropdown" class="inline-flex">
    <vs-dropdown
      :color="AISEA_COLOR.BLUE"
      class="cursor-pointer"
      vs-trigger-click
    >
      <feather-icon
        class="action-button-icon"
        svgClasses="h-6 w-6"
        icon="MoreVerticalIcon"
      ></feather-icon>
      <vs-dropdown-menu class="content-dropdown-menu">
        <vs-dropdown-item
          v-if="!isFolder && isPreview"
          @click="togglePreview()"
        >
          <span class="flex items-center">
            <feather-icon icon="EyeIcon" svgClasses="h-4 w-4" class="mr-2" />
            <span>プレビュー</span>
          </span>
        </vs-dropdown-item>

        <vs-dropdown-item v-if="!isFolder" @click="toggleDownload()">
          <span class="flex items-center">
            <feather-icon
              icon="DownloadIcon"
              svgClasses="h-4 w-4"
              class="mr-2"
            />
            <span>ダウンロード</span>
          </span>
        </vs-dropdown-item>

        <vs-dropdown-item v-if="!isFolder && isPreview" @click="togglePrint()">
          <span class="flex items-center">
            <feather-icon
              icon="PrinterIcon"
              svgClasses="h-4 w-4"
              class="mr-2"
            />
            <span>プリント</span>
          </span>
        </vs-dropdown-item>

        <span v-if="!isFolder">
          <vs-divider class="m-0 px-2 py-1" />
        </span>

        <vs-dropdown-item @click="toggleEditName()">
          <span class="flex items-center">
            <feather-icon icon="EditIcon" svgClasses="h-4 w-4" class="mr-2" />
            <span>名前の編集</span>
          </span>
        </vs-dropdown-item>

        <vs-dropdown-item @click="toggleMoveFolder()">
          <span class="flex items-center">
            <feather-icon icon="FolderIcon" svgClasses="h-4 w-4" class="mr-2" />
            <span>移動</span>
          </span>
        </vs-dropdown-item>

        <vs-dropdown-item @click="toggleCopy()">
          <span class="flex items-center">
            <feather-icon icon="CopyIcon" svgClasses="h-4 w-4" class="mr-2" />
            <span>コピー</span>
          </span>
        </vs-dropdown-item>

        <vs-dropdown-item v-if="!isFolder">
          <span
            class="flex items-center"
            @click="toggleImportant(!document.important)"
          >
            <feather-icon icon="StarIcon" svgClasses="h-4 w-4" class="mr-2" />
            <span>{{ importantText }}</span>
          </span>
        </vs-dropdown-item>

        <vs-dropdown-item v-if="!isFolder" @click="toggleFileInfo()">
          <span class="flex items-center">
            <feather-icon icon="InfoIcon" svgClasses="h-4 w-4" class="mr-2" />
            <span>ファイル情報</span>
          </span>
        </vs-dropdown-item>

        <span>
          <vs-divider class="m-0 px-2 py-1" />
        </span>

        <vs-dropdown-item @click="toggleDelete()">
          <span class="flex items-center">
            <feather-icon icon="TrashIcon" svgClasses="h-4 w-4" class="mr-2" />
            <!-- <span>ゴミ箱へ移動</span> -->
            <span>削除</span>
          </span>
        </vs-dropdown-item>
      </vs-dropdown-menu>
    </vs-dropdown>
    <document-edit-name-dialog
      :document="document"
      ref="DocumentEditNameDialog"
    >
    </document-edit-name-dialog>
    <document-move-dialog
      :isFolder="isFolder"
      :moveTargetDocments="selectDocuments"
      ref="DocumentMoveDialog"
    ></document-move-dialog>
    <document-copy-dialog
      ref="DocumentCopyDialog"
      :copyTargetDocments="selectDocuments"
    >
    </document-copy-dialog>
  </div>
</template>

<script>
import { DOCUMENT_KIND } from "@/config/const";
import { ColorMixin, DocumentMixin } from "@/mixins";
import { createNamespacedHelpers } from "vuex";
import DocumentEditNameDialog from "../../dialog/DocumentEditNameDialog"
import DocumentMoveDialog from "../../dialog/DocumentMoveDialog"
import DocumentCopyDialog from "../../dialog/DocumentCopyDialog"
import { TASK_MANAGER_CATEGORY, TASK_MANAGER_STATUS } from "@/config/const";
import _ from "lodash"


const {
  mapState: mapStateOfEnterpriseDocumentManager,
  mapActions: mapActionsOfEnterpriseDocumentManager,
  mapMutations: mapMutationsOfEnterpriseDocumentManager,
} = createNamespacedHelpers("enterpriseDocumentManager");

const {
  mapActions: MapActionsOfBgTaskManager,
} = createNamespacedHelpers("enterpriseBackgroundTaskManager");

export default {
  mixins: [ColorMixin, DocumentMixin],
  components: { DocumentEditNameDialog, DocumentMoveDialog, DocumentCopyDialog },
  props: {
    document: Object,
    isFolder: Boolean
  },
  data () {
    return {
      task: null,
      selectDocuments: []
    }
  },
  computed: {
    ...mapStateOfEnterpriseDocumentManager(["vesselId"]),
    kind () {
      if (this.isFolder) return "folder"
      return this.getDocumentMimeKind(this.document.type)
    },
    isPreview () {
      return this.kind === DOCUMENT_KIND.IMAGE || this.kind === DOCUMENT_KIND.PDF;
    },
    importantText () {
      const text = this.document.important ? "重要書類から削除" : "重要書類へ追加"
      return text
    }
  },
  methods: {
    ...mapMutationsOfEnterpriseDocumentManager([
      "SET_CONTENT_INFO_SIDEBAR_ACTIVE",
      "SET_SELECTED_DOCUMENT",
      "ADD_SELECTED_MOVE_SOURCE",

    ]),
    ...mapActionsOfEnterpriseDocumentManager([
      "getFileUrl",
      "downloadFile",
      "moveFolder",
      "deleteFile",
      "deleteFolder",
      "setImportantFile",
      "printFile",
    ]),
    ...MapActionsOfBgTaskManager(["addDownloadTask", "updateTask"]),
    async togglePreview () {
      this.$vs.loading();
      try {
        const url = await this.getFileUrl(this.document.path);
        window.open(url, "_blank");
      } catch (e) {
        this.$vs.notify({
          title: "画像情報の取得に失敗しました",
          color: "danger",
          iconPack: "feather",
          icon: "icon-x-square"
        });
      }
      this.$vs.loading.close();
    },
    async togglePrint () {
      try {
        this.$vs.loading();
        await this.printFile(this.document)
        this.$vs.loading.close();
      } catch (e) {
        this.$vs.loading.close();
        this.$vs.notify({
          title: "プリントに失敗しました",
          color: "danger",
          iconPack: "feather",
          icon: "icon-x-square"
        });
      }
    },
    async toggleDownload () {
      try {
        const task = {
          name: this.document.name,
          type: TASK_MANAGER_CATEGORY.DOWNLOAD,
          status: TASK_MANAGER_STATUS.PROGRESS
        }
        this.$vs.notify({
          title: `船舶書類ダウンロード`,
          text: `書類のダウンロードを開始しました。進捗状況はタスクマネージャーにて確認可能です。`,
          color: "success",
          iconPack: "feather",
          icon: "icon-check",
          time: 5000,
          click: () => { this.clickNotify(task) },
        });
        await this.startBackgroundTask();
        await this.downloadFile(this.document)
        await this.completedBackgroundTask();
        this.$vs.notify({
          title: `船舶書類ダウンロード`,
          text: `書類のダウンロードが完了しました。`,
          color: "success",
          iconPack: "feather",
          icon: "icon-check",
          time: 5000,
          click: () => { this.clickNotify(task) },
        });

      } catch (e) {
        console.error(e)
        this.$vs.loading.close();
        this.$vs.notify({
          title: "ダウンロードに失敗しました",
          color: "danger",
          iconPack: "feather",
          icon: "icon-x-square"
        });
      }
    },
    toggleEditName () {
      this.$refs.DocumentEditNameDialog.show(this.document, this.isFolder);
    },
    toggleMoveFolder () {
      this.selectDocuments = [_.cloneDeep(this.document)];
      this.$refs.DocumentMoveDialog.show();
    },
    toggleCopy(){
      this.selectDocuments = [_.cloneDeep(this.document)];
      this.$refs.DocumentCopyDialog.show();
    },
    toggleFileInfo () {
      this.SET_SELECTED_DOCUMENT(this.document)
      this.SET_CONTENT_INFO_SIDEBAR_ACTIVE(true);
    },
    toggleDelete () {
      const deleteItem = this.isFolder ? "フォルダ" : "ファイル"
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: `${deleteItem}の削除`,
        text: this.document.name + "を完全に削除しますか？削除後は復旧できません",
        acceptText: "削除する",
        cancelText: "キャンセル",
        accept: this.deleteDocument
      });
    },
    async toggleImportant (important) {
      try {
        const _important = _.cloneDeep(important);
        const _name = _.cloneDeep(this.document.name)
        this.$vs.loading();
        const payload = {
          path: this.document.path,
          important: _important
        };
        await this.setImportantFile(payload)

        const msg = _important
          ? `「${_name}」を重要書類へ追加しました`
          : `「${_name}」を重要書類から解除しました`

        this.$vs.notify({
          title: msg,
          color: "success",
          iconPack: "feather",
          icon: "icon-check"
        });
        this.$vs.loading.close();
      } catch (error) {
        console.error(error);
        this.$vs.notify({
          title: `重要書類の設定に失敗しました`,
          color: "danger",
          iconPack: "feather",
          icon: "icon-x-square"
        });
        this.$vs.loading.close();
      }
    },
    async deleteDocument () {
      const deleteItem = _.cloneDeep(this.document);
      try {
        this.$vs.loading();
        if (this.isFolder) {
          await this.deleteFolder(deleteItem.path)
        } else {
          await this.deleteFile(deleteItem.path)
        }

        this.$vs.notify({
          title: `「${deleteItem.name}」を削除しました`,
          color: "success",
          iconPack: "feather",
          icon: "icon-check"
        });
        this.$vs.loading.close();
      } catch (error) {
        console.error(error);
        this.$vs.notify({
          title: `「${deleteItem.name}」の削除に失敗しました`,
          color: "danger",
          iconPack: "feather",
          icon: "icon-x-square"
        });
        this.$vs.loading.close();
      }
    },
    async startBackgroundTask () {
      const _task = {
        name: this.document.name,
        props: {
          bytes: this.document.size,
          contentType: this.document.type,
          vesselId: this.vesselId
        },
      };
      this.task = await this.addDownloadTask(_task)
    },
    async completedBackgroundTask () {
      const payload = {
        id: this.task.id,
        body: {
          name: this.task.name,
          status: TASK_MANAGER_STATUS.COMPLETED,
          url: this.document.path,
        }
      }
      await this.updateTask(payload)
      this.task = null;
    },
    clickNotify (task) {
      this.$router.push({
        name: "task-manager",
        params: { name: task.name, type: task.type, status: task.status }
      });
    },
  }
}
</script>


<style lang="scss">
@import "src/assets/scss/aisea/variables";
@import "src/assets/scss/vuexy/variables";

.content-dropdown-menu {
  width: 200px;

  .vs-dropdown--menu--after {
    display: none;
  }
}

.action-button-icon {
  color: $aisea-gray;
}
</style>